import * as React from "react";
import pdf from "@react-pdf/renderer";

const { Text, View } = pdf;
const ReportHeader = ({
  translate,
  title,
  subtitle,
  subtitleText,
  otherParams
}: {
  translate?: any;
  title?: string;
  subtitle?: string;
  subtitleText?: string;
  otherParams?: any;
}) => {
  return (
    <View
      style={{
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#CDCDCD",
        padding: "0pt 5pt 5pt",
        marginLeft: "5pt",
        marginBottom: "5pt"
      }}
    >
      <Text
        style={{
          fontSize: "14pt",
          padding: "0pt 5pt 0pt 5pt",
          fontFamily: "Segoe UI"
        }}
      >
        {title}
      </Text>
      {subtitle && (
        <Text
          style={{
            fontSize: "8pt",
            padding: "0pt 5pt 0pt",
            fontFamily: "Segoe UI"
          }}
        >{`${subtitleText}: ${subtitle}`}</Text>
      )}
      {otherParams && otherParams}
    </View>
  );
};

export default ReportHeader;
